import React from "react";

interface FlagCircleProps {
  /**
   * ISO 3166-1 alpha-2 country code (e.g., "mx", "us", "it")
   */
  iso2?: string;
  /**
   * Size in pixels
   */
  size?: number;
  /**
   * Custom function to build the flag image URL
   */
  srcBuilder?: (countryCode: string) => string;
}

/**
 * A circular flag component that displays country flags from flagcdn.com
 * Uses background-image for clean circular cropping without artifacts.
 */
export const FlagCircle: React.FC<FlagCircleProps> = ({
  iso2 = "mx",
  size = 24,
  srcBuilder = (cc) => `https://flagcdn.com/w80/${cc.toLowerCase()}.png`,
}) => {
  const src = srcBuilder(iso2);

  return (
    <span
      role="img"
      aria-label={`Flag of ${iso2.toUpperCase()}`}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        borderRadius: "50%",
        display: "inline-block",
        backgroundImage: `url(${src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    />
  );
};
